import { Directive, ElementRef, HostBinding, Input, OnDestroy, OnInit, Renderer2, inject } from '@angular/core'

/**
 * @public
 */
@Directive({
  selector: 'slot[gpeiSelectorBasedSlot][name][select]',
  standalone: true
})
export class SelectorBasedSlotDirective implements OnInit, OnDestroy {

  private readonly _renderer2 = inject(Renderer2)
  private readonly _elementRef = inject(ElementRef<HTMLSlotElement>)

  private _clearSlotChangeListener: () => void

  @Input()
  @HostBinding()
  name: string

  @Input()
  @HostBinding()
  select: string

  @Input()
  @HostBinding()
  slot: HTMLSlotElement

  ngOnInit(): void {
    this._clearSlotChangeListener = this._renderer2.listen(this.slot, 'slotchange', () => this.onSlotChange())
  }

  ngOnDestroy(): void {
    this._clearSlotChangeListener?.()
  }

  onSlotChange(): void {
    this.assignElements(this.slot)
  }

  assignElements(source: HTMLSlotElement): void {
    let targetElements = source
      .assignedElements()
      .filter(it => it.matches(this.select) && it.slot !== this.name)

    this._elementRef.nativeElement.assign(...targetElements)

    targetElements.forEach(it => {
      this._renderer2.setAttribute(it, 'slot', this.name)
    })
  }

}
